import { render, staticRenderFns } from "./BundlePopup.vue?vue&type=template&id=58f8d25d&scoped=true&"
import script from "./BundlePopup.vue?vue&type=script&lang=js&"
export * from "./BundlePopup.vue?vue&type=script&lang=js&"
import style0 from "./BundlePopup.vue?vue&type=style&index=0&id=58f8d25d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8d25d",
  null
  
)

export default component.exports